import React from "react";
import localData from "../../../localData";

export default function ProjectCard({
    title,
    description,
    cover,
    tools,
    websiteLink,
    codeLink,
    isUpcoming,
    setIsModalShown,
}) {
    const { play, code } = localData.svgs;

    return (
        <div className="card project-card" data-lazy="fade-up">
            <h4 className="card-title">{title}</h4>
            <p className="card-description">{description}</p>
            <div className="card-img">{cover}</div>
            <div className="card-footer">
                <a
                    className="card-link card-link-play"
                    href={websiteLink}
                    onClick={() => (isUpcoming ? setIsModalShown(true) : "")}
                    target={isUpcoming ? "_self" : "_blank"}
                >
                    {play}
                </a>
                <div className="wrapper">
                    <a
                        className="card-link card-link-code"
                        href={codeLink}
                        onClick={() => (isUpcoming ? setIsModalShown(true) : "")}
                        target={isUpcoming ? "_self" : "_blank"}
                    >
                        {code}
                    </a>
                    <p className="card-tools">
                        {tools.map((tool, index) => (
                            <span className="d-block" key={index}>
                                {tool}
                            </span>
                        ))}
                    </p>
                </div>
            </div>
        </div>
    );
}
